import { name } from 'file-loader'
import * as types from './types'

// ----------------------------------
// Job Offer LIST ACTIONS
// ----------------------------------
export const updateJobOFFerList = (value) => ({
    type: types.UPDATE_SEARCHLIST,
    payload: value
})

export const applyFilters = (searchModel) => ({
    type: types.APPLY_FILTERS,
    payload: searchModel
})

export const resetFilters = () => ({
    type: types.RESET_FILTERS,
    payload: ''
})

export const resetResults = () => ({
    type: types.RESET_RESULTS,
    payload: ''
})

export const changeFilterData = (payload) => ({
    type: types.CHG_FILTER_DATA,
    payload: payload
})

export const changeFilterPage = payload => ({
    type: types.CHG_FILTER_PAGE,
    payload: payload
})

export const changeFilterSort = payload => ({
    type: types.CHG_FILTER_SORT,
    payload: payload
})

export const changeFilterRowsPerPage = payload => ({
    type: types.CHG_FILTER_PAGE_SIZE,
    payload: payload
})

export const isLoading = (loading) => ({
    type: types.IS_LOADING,
    payload: loading
})

export const setConfirmationModal = (confirmModel) => ({
    type: types.SET_CONFIRM_MODAL,
    payload: confirmModel
})

export const hideConfirmationModal = () => ({
    type: types.HIDE_CONFIRM_MODAL,
    payload: ''
})

export const showConfirmationModal = () => ({
    type: types.SHOW_CONFIRM_MODAL,
    payload: ''
})

export const setListAlert = (payload) => ({
    type: types.SET_LIST_ALERT,
    payload: payload
})

export const hideListAlert = () => ({
    type: types.HIDE_LIST_ALERT,
    payload: ''
})

export const changeSelectedRows = (payload) => ({
    type: types.CHG_SELECTED_ROWS,
    payload: payload
})

//-------------------------------
// JobOffer ADD ACTIONS
//-------------------------------
export const resetAddData = () => ({
    type: types.RESET_ADD_DATA,
    payload: '',
})

export const showLoading = (loading) => ({
    type: types.INSERT_LOADING,
    payload: loading
})

export const changeAddData = (payload) => ({
    type: types.CHG_FIELD,
    payload: payload
})

export const setJobOfferAdd = (data, mode) => ({
    type: types.SET_ADD_DATA,
    payload: data,
    mode: mode
})

export const hideAddAlert = () => ({
    type: types.HIDE_ADD_ALERT,
    payload: ''
})

export const hideShowModal = (isShow, modal) => ({
    type: types.HIDE_SHOW_MODAL,
    payload: isShow,
    typeModal: modal
})

export const hasAddLoaded = (hasLoaded) => ({
    type: types.HAS_ADD_LOADED,
    payload: hasLoaded
})

export const updateAddAlertData = (alertModel) => ({
    type: types.UPD_ADD_ALERT,
    payload: alertModel
})

export const updateInfoData = (infoModal) => ({
    type: types.UPDATE_INFO,
    payload: infoModal
})

export const setAddViewMode = (mode) => ({
    type: types.UPD_ADD_MODE,
    payload: mode
})

export const setAddEmailTemplate = (template) => ({
    type: types.SET_ADD_EMAIL_TEMPLATE,
    payload: template
})
